<template>
  <TransitionGroup name="notifications-list" class="notifications">
    <div class="notification" v-for="(notification, key) in notifications" :key="notification.key" :class="['notification_' + notification.type]">
      <div class="notification__top-wrap">
        <div class="notification__text texts texts_heading-15">
          {{ notification.text }}
        </div>

        <a class="notification__close" href="javascript:void(0);" @click.prevent="removeNotification(key)">
        </a>
      </div>

      <div class="notification__info-wrap" v-if="notification.data && typesToShowData.includes(notification.data.type)">
        <div class="notification__product texts texts_point-16">
          {{ notification.data.name }}
        </div>

        <div class="notification__price texts texts_price">
          {{ notification.data.price }}
        </div>
      </div>

      <div class="notification__button-wrap" v-if="notification.data && notification.data.type === 'favorites'">
        <a href="/favorites"
           class="button button__fav button_yellow texts texts_button-mob"
           title="В избранное"
        >
          В избранное
        </a>
      </div>

      <div class="notification__button-wrap" v-if="notification.data && notification.data.type === 'compare'">
        <a href="/compare"
           class="button button__fav button_yellow texts texts_button-mob"
           title="Сравнение"
        >
          Сравнение
        </a>
      </div>
    </div>
  </TransitionGroup>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: "TheNotifications",
  data() {
    return {
      typesToShowData: ['favorites', 'compare'],
    }
  },
  computed: {
    ...mapState('notification', [
      'notifications'
    ])
  },
  methods: {
    ...mapMutations('notification', [
      'removeNotification'
    ])
  }
}
</script>

<style lang="scss">

</style>